<template>
  <div
    class="base-image-input mx-auto"
    :style="{ 'background-image': `url(${imageData[0]}), url(${imageData[1]})` }"
    @click="chooseImage"
  >
    <span
      v-if="!imageData.length"
      class="placeholder"
    >
      {{ $t('offerImageInput.Add 2 images') }}
    </span>
    <input
      class="file-input"
      accept="image/png, image/jpeg"
      ref="fileInput"
      type="file"
      multiple
      @input="onSelectFile"
    >
  </div>
</template>

<script>
    export default {
        data() {
            return {
                imageData: []
            }
        },
        methods: {
            chooseImage() {
                this.$refs.fileInput.click()
            },
            onSelectFile() {
                const input = this.$refs.fileInput;
                const files = input.files;

                if (files) {
                    for (let file of files) {
                        const reader = new FileReader;
                        reader.onload = e => {
                            this.imageData.push(e.target.result)
                        };
                        reader.readAsDataURL(file);
                        this.$emit('input', file);
                    }
                    this.$emit('uploaded', this.imageData);

                }
            }
        }
    }
</script>

<style scoped>
  .base-image-input {
    display: block;
    width: 160px;
    height: 70px;
    cursor: pointer;
    background-position: left center, right center;
    background-repeat: no-repeat, no-repeat;
    background-size: 60px;
    border: 1px solid;
  }

  .placeholder {
    background: #F0F0F0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #E0E0E0;
  }

  .file-input {
    display: none;
  }
</style>
